import Head from 'next/head'
import Image from 'next/image'
import styles from '@/styles/Home.module.css'
import Html5QrcodePlugin from '@/components/Html5QrcodePlugin'
import { AppBar, Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton, Input, Slide, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography, tableCellClasses, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import { Share } from '@mui/icons-material';
import { colors } from '@/constants/colors'
import React, { useState } from 'react'
import { TransitionProps } from '@mui/material/transitions'
import axios from 'axios'
import { GetServerSideProps, NextPage } from 'next'
import { toast } from 'react-toastify'
import VerifiedIcon from '@mui/icons-material/Verified';
import { protocol } from '@/utils/frontend'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LanguageIcon from '@mui/icons-material/Language';
import eventConfig from "./../../public/event.config.json"

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const ariaLabel = { 'aria-label': 'description' };

type Props = {
  host: string;
  event: {
    name: string;
    event_name: string;
    date: string;
    date_start: string;
    date_end: string;
    location: string;
    location_frame_link: string;
    organiser: {
      name: string;
    }
  }
};

const Home: NextPage<Props> = ({ host, event }) => {
  // console.log('event', event);
  const [open, setOpen] = useState(false);
  const [dialogLogin, setOpenDialogLogin] = useState(false);
  const [email, setemail] = useState("");
  const [name, setname] = useState("")
  const [title, settitle] = useState("")
  const [company, setcompany] = useState("")
  // const [contact, setcontact] = useState("");
  const [attendance, setattendance] = useState(1);
  const [loading, setloading] = useState(false)
  const [success, setsuccess] = useState(false)
  const handleClickOpen = () => {
    setOpen(true);
    setsuccess(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRegister = async () => {
    setloading(true);
    try {
      await axios.post(`${protocol}://${host}/api/register`, {
        email, name, title, company, attendance
      })
      setsuccess(true);

    } catch (error: any) {
      toast.error(error.response.data.message);
    } finally {
      setloading(false);
    }
  }

  return (
    <>
      <Head>
        <title>{event.name}</title>
      </Head>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ maxWidth: 600, height: '100vh', position: 'relative', background: '#ffffff' }}>
          <AppBar position="static" color='default'>
            <Toolbar sx={{ padding: '12px 0 12px 20px' }}>
              <Box sx={{flex: '1'}}>
                <img src="/logo.png" alt="" style={{ width: '100px'}} />
              </Box>
              <IconButton
                onClick={() => {
                  navigator.clipboard.writeText(host)
                  toast.success('Link copied', { position: 'bottom-center' })
                }}
                size="large"
              >
                <img src="/share.svg" alt="" />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Container style={{ padding: 0, background: '#ffffff' }}>
            <img src="/edm.jpeg" alt="" style={{ width: '100%' }} />
            <Stack sx={{ padding: '0 20px', overflow: 'auto', marginBottom: '50px' }}>
              {/* <Box display={'flex'} sx={{ marginTop: '32px' }}>
                <img src="/calendar.svg" alt="" style={{ backgroundColor: colors.GREY, padding: 14, width: 24, height: 24, marginRight: 18 }} />
                <Stack>
                  <Typography variant='body1' fontSize={22} color={colors.BLUE}>Date & Time</Typography>
                  <Typography fontSize={18}>{event.date_start}</Typography>
                  <Typography fontSize={18}>{event.date_end}</Typography>
                </Stack>
              </Box> */}
              <Box display={'flex'} sx={{ marginTop: '32px' }}>
                <img src="/shirt.svg" alt="" style={{ backgroundColor: colors.GREY, padding: 14, width: 24, height: 24, marginRight: 18 }} />
                <Stack>
                  <Typography variant='body1' fontSize={22} color={colors.BLUE}>Dress Code</Typography>
                  <Typography fontSize={18}>Smart Casual</Typography>
                </Stack>
              </Box>
              <Box display={'flex'} sx={{ marginTop: '32px', marginBottom: '20px' }}>
                <LocationOnIcon style={{ backgroundColor: colors.GREY, padding: 14, width: 24, height: 24, marginRight: 18 }} color='primary' />
                {/* <img src="/calendar.svg" alt="" style={{ backgroundColor: colors.GREY, padding: 14, width: 24, height: 24, marginRight: 18 }} /> */}
                <Stack>
                  <Typography variant='body1' fontSize={22} color={colors.BLUE}>Location</Typography>
                  <Typography fontSize={18}>Pan Pacific Orchard,<br/>Claymore Ballroom, Level 18</Typography>
                  <Typography fontSize={18} sx={{ marginTop: '32px' }}>More parking spaces available at Orchard Towers & Palais Renaissance</Typography>
                </Stack>
              </Box>
              <iframe src={event.location_frame_link} height="450" loading="lazy" style={{ border: 0 }}></iframe>
              {/* <Typography variant='h3' fontSize={36} marginTop={2}>About the organiser</Typography> */}
            </Stack>
            <Box sx={{ position: 'sticky', bottom: 0, width: '100%', color: 'white', borderTop: '1px solid rgba(0,0,0,0.2)', background: 'white', display: 'none' }}>
              <Box sx={{ padding: '24px 32px' }}>
                <Button variant='contained' sx={{ color: 'white', borderRadius: 2 }} fullWidth onClick={handleClickOpen}>
                  RSVP
                </Button>
              </Box>
            </Box>
          </Container>
        </div>
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={'xs'}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{ sx: { borderRadius: 4, padding: '20px 32px' } }}
      >
        <DialogTitle sx={{ display: success ? 'none' : 'visible' }}>
          <Typography color={colors.BLUE} fontSize={'24px'} textAlign={'center'}>RSVP</Typography>
        </DialogTitle>
        <DialogContent style={{ padding: '20px 12px' }}>
          <Box textAlign={'center'} sx={{ display: success ? 'visible' : 'none' }}>
            <VerifiedIcon style={{ width: 150, height: 150 }} color='success' />
            { (attendance == 0) ?
              (<Typography>Thank you for your submission!</Typography>)
              :(<Typography>Thank you for your submission. Please check your email for your unique QR code.</Typography>)
            }
            
          </Box>
          <Box sx={{ display: success ? 'none' : 'visible' }}>
          <Input type='email' disableUnderline={true} placeholder="Email" inputProps={ariaLabel} fullWidth
              onChange={(e) => setemail(e.target.value)}
              sx={{
                background: colors.GREY, borderRadius: '10px',
                marginBottom: '12px',
                input: { textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderRadius: '10px' }
              }} />

            <Input type='text' disableUnderline={true} placeholder="Name" inputProps={ariaLabel} fullWidth
              onChange={(e) => setname(e.target.value)}
              sx={{
                background: colors.GREY, borderRadius: '10px',
                marginBottom: '12px',
                input: { textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderRadius: '10px' }
              }} />

            <Input type='text' disableUnderline={true} placeholder="Title" inputProps={ariaLabel} fullWidth
              onChange={(e) => settitle(e.target.value)}
              sx={{
                background: colors.GREY, borderRadius: '10px',
                marginBottom: '12px',
                input: { textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderRadius: '10px' }
              }} />

            <Input type='text' disableUnderline={true} placeholder="Company" inputProps={ariaLabel} fullWidth
              onChange={(e) => setcompany(e.target.value)}
              sx={{
                background: colors.GREY, borderRadius: '10px',
                marginBottom: '12px',
                input: { textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderRadius: '10px' }
              }} />

            {/* <Input type='text' disableUnderline={true} placeholder="Contact" inputProps={ariaLabel} fullWidth
              value={contact}
              onChange={(event) => {
                const re = /^[0-9\b]+$/;

                if (event.target.value === '' || re.test(event.target.value)) {
                  setcontact(event.target.value);
                }
              }}
              sx={{
                background: colors.GREY, borderRadius: '10px',
                marginBottom: '12px',
                input: { textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderRadius: '10px' }
              }} /> */}

            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value= {attendance}
                onChange={(e) => setattendance(parseInt(String(e.target.value)))}
                sx={{
                  background: colors.GREY, borderRadius: '10px',
                  marginBottom: '12px',
                  input: { textAlign: 'center', paddingTop: '10px', paddingBottom: '10px', borderRadius: '10px' }
                }}
              >
                <MenuItem value={1} selected>Yes, I am attending.</MenuItem>
                <MenuItem value={0}>No, I am not attending.</MenuItem>
              </Select>
            </FormControl>

          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', margin: '0 4px', display: success ? 'none' : 'visible' }}>
          <LoadingButton variant='contained' fullWidth sx={{ borderRadius: 2 }} onClick={handleRegister} loading={loading}>Submit</LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Home;
export const getServerSideProps: GetServerSideProps<Props> =
  async context => {
    // console.log('config', eventConfig);

    return {
      props: {
        host: context.req.headers.host || "localhost:3000",
        event: eventConfig
      }
    }
  };